export default __webpack_public_path__ + "static/media/redemption.f2f9e63b.png";